<template>
  <div>
    <b-form-group class="filter" :label="title" label-for="filter">
      <multiselect
        v-model="selectedItem"
        label="text"
        track-by="value"
        placeholder="Selecione"
        :close-on-select="true"
        :multiple="false"
        :options="options"
        :preselect-first="false"
        :showLabels="false"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "SuspenseListFilter",
  props: {
    title: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    selectedItem: {
      get() {
        const found = this.options.find(option => option.text === this.value);
        return found ? found : undefined;
      },
      set(newItem) {
        if (newItem && newItem.text) {
          this.$emit("update:value", newItem.text);
        } else {
          this.$emit("update:value", "");
        }
        this.emitFilterChange();
      }
    }
  },
  methods: {
    emitFilterChange() {
      this.$emit("filter-changed");
    }
  }
};
</script>

<style scoped>
.filter {
  min-width: 70px;
}
</style>
